import { all, takeEvery } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"

import * as ItemTypes from "../../items/types"
import moment from "moment"
import { makeSagaQuery } from "../utils"
import apiServerConstants from "../apiServerConstants"
import { HTTP_VERB } from "../../../lib/utils"

function* loadBusinessSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/business?page=${0}&size=${1000000}`,
    HTTP_VERB.GET,
    null,
    ItemTypes.Business,
    true,
    response => {

      let businesses = response.body
      if (!(businesses instanceof Array)) return

      businesses = businesses.map(item => {
        item.createdOnFormatted = item.createdOn ? moment(item.createdOn).format('ll') : ''
        return item
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Business,
        data: businesses
      }
    }
  )
}

function* businessSaga() {
  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Business,
      loadBusinessSaga
    ),
  ])
}

export default businessSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/business.js